export interface FilterOption {
  id: string | number;
  name: string;
}

interface FilterBarProps {
  label: string;
  options: FilterOption[];
  selectedOptionId: string | number;
  onOptionClick: (optionId: string | number) => void;
  disabled?: boolean;
  className?: string;
  dataCy?: string;
}

function FilterBar({
  label,
  options,
  selectedOptionId,
  onOptionClick,
  disabled,
  className,
  dataCy = 'filter-bar',
}: FilterBarProps) {
  function handleOptionClick(optionId: string | number) {
    if (!disabled) {
      onOptionClick(optionId);
    }
  }

  return (
    <div
      data-cy={dataCy}
      className={`px-2 md:px-3 overflow-y-hidden lg:px-4 no-scrollbar md:mt-3 overflow-x-scroll h-[40px] border-b border-[#D0D0D0] flex items-center ${className ?? ''}`}
    >
      <span className='mr-5 md:mr-6 mb-1 font-semibold text-gray-500'>{label}:</span>
      <ol className='flex items-center gap-4 md:gap-6'>
        {options.map((option) => {
          const active = selectedOptionId === option.id;

          return (
            <li key={option.id}>
              <button
                disabled={disabled}
                onClick={() => handleOptionClick(option.id)}
                className={`py-1.5 min-w-[max-content] border-transparent border-b-[3px] text-[1.125rem] transition-all h-full duration-400 ${
                  active ? '!text-[#7AD817] font-bold !border-[#7AD817]' : ''
                } ${disabled ? 'cursor-not-allowed opacity-50' : ''} ${
                  !active && !disabled ? 'hover:text-teal-600 hover:border-teal-600 ' : ''
                }`}
              >
                {option.name}
              </button>
            </li>
          );
        })}
      </ol>
    </div>
  );
}

export default FilterBar;
